const guiColors = {
    'motion-primary': '#4aa8ff', // bright blue
    'motion-dark': '#3484CF', // way darker blue
    'motion-primary-transparent': '#4aa8ffe6', // semi-transparent blue
    'motion-tertiary': '#4092de', // darker blue

    'looks-secondary': '#4aa8ff', // bright blue
    'looks-transparent': '#4aa8ff59', // more transparent blue
    'looks-light-transparent': '#4aa8ff26', // very transparent blue
    'looks-secondary-dark': '#1065CC', // dark blue
	
	'looks-secondary-light': '#96CDFF', //light
    'looks-secondary-lighter': '#BFE0FF', //lighter
    'looks-secondary-darker': '#0043A3', //darker
    'looks-secondary-deep-dark': '#002C87', //darkest

    'extensions-primary': '#9ecdf9', // light blue
    'extensions-tertiary': '#76baf9', // medium blue
    'extensions-transparent': '#76baf935', // semi-transparent blue
    'extensions-light': '#b0d6f9', // very light blue
	
    'menu-bar-background': '#4aa8ff', // bright blue
    'menu-bar-background-dark': '#3484CF', // way darker blue

    'drop-highlight': '#9ecdf9' // light blue
};

const blockColors = {
    checkboxActiveBackground: '#4aa8ff', // bright blue
    checkboxActiveBorder: '#4092de' // darker blue
};

export {
    guiColors,
    blockColors
};
